import type { CheckboxVariantProps } from "@daangn/carotene";
import { unstable_checkboxStyle } from "@daangn/carotene";
import IconCheckmarkFill from "@karrotmarket/react-monochrome-icon/IconCheckmarkFill";
import clsx from "clsx";
import * as React from "react";

import type { UseCheckboxProps } from "~/design-system/components/Checkbox/useCheckbox";
import type { Assign } from "~/design-system/util/type";

import { Link } from "~/remix-lib";
import { useCheckboxAnchor } from "./useCheckboxAnchor";

export interface CheckboxProps
  extends Assign<React.HTMLAttributes<HTMLAnchorElement>, UseCheckboxProps>,
    CheckboxVariantProps {
  label: string;
  href: string;
}

const CheckboxAnchor = React.forwardRef<HTMLAnchorElement, CheckboxProps>(
  ({ className, href, size, label, ...otherProps }, ref) => {
    const {
      rootProps,
      restProps,
      controlProps,
      stateProps,
      labelProps,
      anchorProps,
    } = useCheckboxAnchor({
      href,
      label,
      ...otherProps,
    });
    const classNames = unstable_checkboxStyle({ size });

    return (
      <Link
        ref={ref}
        href={href}
        className={clsx(classNames.root, className)}
        {...rootProps}
        {...restProps}
        {...anchorProps}
      >
        <div {...controlProps} className={classNames.control}>
          <IconCheckmarkFill {...stateProps} className={classNames.icon} />
        </div>
        <span {...labelProps} className={clsx(classNames.label)}>
          {label}
        </span>
      </Link>
    );
  },
);
CheckboxAnchor.displayName = "CheckboxAnchor";

export default CheckboxAnchor;
